export default{
    metrySet: {
      enterSetName: "Enter the set name(special characters are not allowed other than, ' ', '-' and '_')",
      setName: "Set Name",
      ok: 'OK',
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      createSetFromFilter: "Create Set From Filter",
      createSetFromIds: "Create Set From Selected Items",
      createSetFromfileUpload: 'Create Set From Selected File',
      deleteSet: "Delete Set",
      addSelectedToSet: "Add Selected Items to Set",
      removeSelectedFromSet: "Remove Selected Items from Set",
      setCreateError: "Unexpected error creating set",
      setDeleteError: "Unexpected error deleting set",
      setUpdateError: "Unexpected error updating set",
      getSetsError: "Unexpected error retrieving sets",
      confirmDelete: "Confirm Delete",
      confirmRemove: "Confirm Remove",
      confirmDeleteSet: "Are you sure you want to delete set '{name}'?",
      confirmRemoveFromSet: "Are you sure you want to remove {count} items from set '{name}'",
      confirmRemoveFromSetOne: "Are you sure you want to remove 1 item from set '{name}'",
      duplicateSetName: "Set name '{name}' already exists, please choose another name",
      setNameIsRequired: "Set name is required",
      invalidSetName: 'Invalid Set Name',
      setInvalidFile: 'Uploaded Invalid File',
      isLoading: 'Getting set data...',
      noData: 'No sets found',
      csvFile: 'CSV File to Create Set From',
      csvRadioKey: 'CSV File Type',
      radioId: 'Radio Ids',
      meterId: 'Meter Ids'
    }
}
